<template>
  <!-- <div class="message">
    {{ isLoginSso ? '' : 'Vui lòng đăng nhập bằng SSO để sử dụng tính năng này' }}
  </div> -->
  <div class="if-content">
    <iframe :src="url" allow height="100%" width="100%" loading="lazy" />
  </div>
</template>

<script>
import qs from 'qs';

export default {
  name: 'Redmine',

  data () {
    return {
      isLoginSso: true,
      url: ''
    }
  },

  mounted () {
    const token = localStorage.getItem('token')
    const currentDomain = location.host
    const mapDomain = {
      'localhost:8080': 'https://dev-task-client.nextpay.vn',
      'crm-mynextpay.nextshop.dev': 'https://dev-task-client.nextpay.vn',
      'my.nextpay.global': 'https://task-client.nextpay.vn',
      'my.nextpay.vn': 'https://task-client.nextpay.vn',
      'crm.nextpay.global': 'https://task-client.nextpay.vn',
    }

    const queries = qs.parse(location.search.replace('?', ''));

    this.url = `${mapDomain[currentDomain]}/${queries.url ? queries.url : 'projects'}/?platform=web-iframe&token=${token}`;
  },
}
</script>

<style scoped>
.if-content {
  width: 600px;
  margin: 0 auto;
  height: calc(100vh - 52px);
}

@media only screen and (max-width: 600px) {
  .if-content {
    width: 100% !important;
  }
}
</style>